const _bottoms = {
	'acid-washed-jeans': {
		name: 'acid-washed jeans',
		variations: {
			blue: 'Blue',
			black: 'Black',
		},
	},
	'animal-stripes-skirt': {
		name: 'animal-stripes skirt',
		variations: {
			tiger: 'Tiger',
			zebra: 'Zebra',
		},
	},
	'apron-skirt': {
		name: 'apron skirt',
		variations: {
			purple: 'Purple',
			blue: 'Blue',
			beige: 'Beige',
		},
	},
	'athletic-pants': {
		name: 'athletic pants',
		variations: {
			red: 'Red',
			green: 'Green',
			black: 'Black',
			blue: 'Blue',
			'berry-red': 'Berry red',
			'navy-blue': 'Navy blue',
		},
	},
	'athletic-shorts': {
		name: 'athletic shorts',
		variations: {
			red: 'Red',
			green: 'Green',
			black: 'Black',
			blue: 'Blue',
			'berry-red': 'Berry red',
			'navy-blue': 'Navy blue',
		},
	},
	'basketball-shorts': {
		name: 'basketball shorts',
		variations: {
			purple: 'Purple',
			red: 'Red',
			green: 'Green',
			orange: 'Orange',
			blue: 'Blue',
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			black: 'Black',
		},
	},
	'bell-bottoms': {
		name: 'bell-bottoms',
		variations: {
			orange: 'Orange',
			brown: 'Brown',
			beige: 'Beige',
			green: 'Green',
			blue: 'Blue',
		},
	},
	'belted-wraparound-skirt': {
		name: 'belted wraparound skirt',
		variations: {
			yellow: 'Yellow',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
		},
	},
	'boa-shorts': {
		name: 'boa shorts',
		variations: {
			purple: 'Purple',
			avocado: 'Avocado',
			beige: 'Beige',
			blue: 'Blue',
			red: 'Red',
			orange: 'Orange',
			'peacock-blue': 'Peacock blue',
			black: 'Black',
		},
	},
	'boa-skirt': {
		name: 'boa skirt',
		variations: {
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			red: 'Red',
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			beige: 'Beige',
			brown: 'Brown',
		},
	},
	'bomber-style-skirt': {
		name: 'bomber-style skirt',
		variations: {
			avocado: 'Avocado',
			black: 'Black',
			blue: 'Blue',
			brown: 'Brown',
		},
	},
	'botanical-shorts': {
		name: 'botanical shorts',
		variations: {
			black: 'Black',
			white: 'White',
		},
	},
	'box-pleated-skirt': {
		name: 'box-pleated skirt',
		variations: {
			'light-blue': 'Light blue',
			beige: 'Beige',
			red: 'Red',
			green: 'Green',
		},
	},
	'buttoned-lace-skirt': {
		name: 'buttoned lace skirt',
		variations: {
			yellow: 'Yellow',
			white: 'White',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'buttoned-wraparound-skirt': {
		name: 'buttoned wraparound skirt',
		variations: {
			gray: 'Gray',
			blue: 'Blue',
			orange: 'Orange',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'camo-pants': {
		name: 'camo pants',
		variations: {
			brown: 'Brown',
			avocado: 'Avocado',
			pink: 'Pink',
			blue: 'Blue',
			gray: 'Gray',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'camo-skirt': {
		name: 'camo skirt',
		variations: {
			brown: 'Brown',
			avocado: 'Avocado',
			pink: 'Pink',
			blue: 'Blue',
			gray: 'Gray',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'career-skirt': {
		name: 'career skirt',
		variations: {
			gray: 'Gray',
			beige: 'Beige',
			peach: 'Peach',
			'light-blue': 'Light blue',
			pink: 'Pink',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'cargo-pants': {
		name: 'cargo pants',
		variations: {
			avocado: 'Avocado',
			beige: 'Beige',
			'navy-blue': 'Navy blue',
			mustard: 'Mustard',
			brown: 'Brown',
		},
	},
	'cargo-shorts': {
		name: 'cargo shorts',
		variations: {
			beige: 'Beige',
			'navy-blue': 'Navy blue',
			avocado: 'Avocado',
			camel: 'Camel',
			brown: 'Brown',
		},
	},
	'casual-pants': {
		name: 'casual pants',
		variations: {
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			green: 'Green',
			beige: 'Beige',
			black: 'Black',
			brown: 'Brown',
		},
	},
	'chain-pants': {
		name: 'chain pants',
		variations: {
			red: 'Red',
			blue: 'Blue',
			white: 'White',
			black: 'Black',
		},
	},
	'chino-pants': {
		name: 'chino pants',
		variations: {
			beige: 'Beige',
			brown: 'Brown',
			'navy-blue': 'Navy blue',
			avocado: 'Avocado',
			gray: 'Gray',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'colorful-skirt': {
		name: 'colorful skirt',
		variations: {
			red: 'Red',
			blue: 'Blue',
			pink: 'Pink',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'comedians-pants': {
		name: "comedian's pants",
		variations: {
			orange: 'Orange',
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
			green: 'Green',
			purple: 'Purple',
			aquamarine: 'Aquamarine',
			white: 'White',
		},
	},
	'comic-shorts': {
		name: 'comic shorts',
		variations: {
			black: 'Black',
		},
	},
	'corduroy-pants': {
		name: 'corduroy pants',
		variations: {
			camel: 'Camel',
			brown: 'Brown',
			pink: 'Pink',
			green: 'Green',
			'light-gray': 'Light gray',
			black: 'Black',
		},
	},
	'corduroy-skirt': {
		name: 'corduroy skirt',
		variations: {
			brown: 'Brown',
			camel: 'Camel',
			pink: 'Pink',
			green: 'Green',
			'light-gray': 'Light gray',
			black: 'Black',
		},
	},
	'corte-skirt': {
		name: 'corte skirt',
		variations: {
			blue: 'Blue',
			magenta: 'Magenta',
			green: 'Green',
		},
	},
	'cropped-pants': {
		name: 'cropped pants',
		variations: {
			black: 'Black',
			white: 'White',
			pink: 'Pink',
			'light-blue': 'Light blue',
			beige: 'Beige',
			orange: 'Orange',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'cuffed-pants': {
		name: 'cuffed pants',
		variations: {
			brown: 'Brown',
			purple: 'Purple',
			green: 'Green',
			gray: 'Gray',
		},
	},
	culottes: {
		name: 'culottes',
		variations: {
			'light-blue': 'Light blue',
			white: 'White',
			pink: 'Pink',
			green: 'Green',
		},
	},
	'cut-pleather-skirt': {
		name: 'cut-pleather skirt',
		variations: {
			brown: 'Brown',
			pink: 'Pink',
			'navy-blue': 'Navy blue',
			white: 'White',
		},
	},
	'cycling-shorts': {
		name: 'cycling shorts',
		variations: {
			'blue-and-red': 'Blue & red',
			'black-and-blue': 'Black & blue',
			'black-and-red': 'Black & red',
			'black-and-yellow': 'Black & yellow',
			'red-and-green': 'Red & green',
			'orange-and-red': 'Orange & red',
			'green-and-purple': 'Green & purple',
			'purple-and-pink': 'Purple & pink',
		},
	},
	'dance-warm-up-pants': {
		name: 'dance warm-up pants',
		variations: {
			black: 'Black',
			white: 'White',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'denim-cutoffs': {
		name: 'denim cutoffs',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			'navy-blue': 'Navy blue',
			white: 'White',
			black: 'Black',
		},
	},
	'denim-painters-pants': {
		name: "denim painter's pants",
		variations: {
			'navy-blue': 'Navy blue',
			'light-blue': 'Light blue',
			blue: 'Blue',
			black: 'Black',
			white: 'White',
		},
	},
	'denim-pants': {
		name: 'denim pants',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			'navy-blue': 'Navy blue',
			black: 'Black',
			white: 'White',
		},
	},
	'denim-skirt': {
		name: 'denim skirt',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			'navy-blue': 'Navy blue',
			black: 'Black',
			white: 'White',
		},
	},
	'dotted-shorts': {
		name: 'dotted shorts',
		variations: {
			black: 'Black',
			gray: 'Gray',
		},
	},
	'down-pants': {
		name: 'down pants',
		variations: {
			blue: 'Blue',
			black: 'Black',
			red: 'Red',
			white: 'White',
			green: 'Green',
			yellow: 'Yellow',
			orange: 'Orange',
			lime: 'Lime',
		},
	},
	'down-skirt': {
		name: 'down skirt',
		variations: {
			blue: 'Blue',
			black: 'Black',
			red: 'Red',
			white: 'White',
			green: 'Green',
			yellow: 'Yellow',
			orange: 'Orange',
			lime: 'Lime',
		},
	},
	'draped-skirt': {
		name: 'draped skirt',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
			orange: 'Orange',
			pink: 'Pink',
			purple: 'Purple',
			'light-blue': 'Light blue',
		},
	},
	'dreamy-pants': {
		name: 'dreamy pants',
		variations: {
			pink: 'Pink',
			green: 'Green',
			yellow: 'Yellow',
			blue: 'Blue',
		},
	},
	'dress-pants': {
		name: 'dress pants',
		variations: {
			green: 'Green',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
			'berry-red': 'Berry red',
		},
	},
	'elephant-print-pants': {
		name: 'elephant-print pants',
		variations: {
			red: 'Red',
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
			black: 'Black',
		},
	},
	'embellished-denim-pants': {
		name: 'embellished denim pants',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			black: 'Black',
		},
	},
	'embroidered-floral-skirt': {
		name: 'embroidered floral skirt',
		variations: {
			green: 'Green',
			blue: 'Blue',
			'berry-red': 'Berry red',
		},
	},
	'embroidered-pattern-skirt': {
		name: 'embroidered-pattern skirt',
		variations: {
			blue: 'Blue',
			green: 'Green',
			red: 'Red',
		},
	},
	'explorer-shorts': {
		name: 'explorer shorts',
		variations: {
			camel: 'Camel',
			avocado: 'Avocado',
			beige: 'Beige',
			blue: 'Blue',
		},
	},
	'faux-fur-skirt': {
		name: 'faux-fur skirt',
		variations: {
			'light-blue': 'Light blue',
			pink: 'Pink',
			red: 'Red',
			purple: 'Purple',
			yellow: 'Yellow',
		},
	},
	'faux-shearling-skirt': {
		name: 'faux-shearling skirt',
		variations: {
			beige: 'Beige',
			pink: 'Pink',
			green: 'Green',
			black: 'Black',
			gray: 'Gray',
		},
	},
	'flare-skirt': {
		name: 'flare skirt',
		variations: {
			red: 'Red',
			black: 'Black',
			pink: 'Pink',
			mint: 'Mint',
			'light-blue': 'Light blue',
		},
	},
	'flashy-slacks': {
		name: 'flashy slacks',
		variations: {
			white: 'White',
			black: 'Black',
			purple: 'Purple',
			'berry-red': 'Berry red',
			aquamarine: 'Aquamarine',
			yellow: 'Yellow',
		},
	},
	'floral-lace-skirt': {
		name: 'floral lace skirt',
		variations: {
			'light-blue': 'Light blue',
			pink: 'Pink',
			blue: 'Blue',
			'ruby-red': 'Ruby red',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
			black: 'Black',
		},
	},
	'floral-skirt': {
		name: 'floral skirt',
		variations: {
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			pink: 'Pink',
		},
	},
	'football-pants': {
		name: 'football pants',
		variations: {
			green: 'Green',
			white: 'White',
			yellow: 'Yellow',
			'berry-red': 'Berry red',
			blue: 'Blue',
			turquoise: 'Turquoise',
			red: 'Red',
			black: 'Black',
		},
	},
	'formal-shorts': {
		name: 'formal shorts',
		variations: {
			white: 'White',
			'navy-blue': 'Navy blue',
			pink: 'Pink',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			purple: 'Purple',
			lime: 'Lime',
			beige: 'Beige',
		},
	},
	'frilly-pants': {
		name: 'frilly pants',
		variations: {
			yellow: 'Yellow',
			mint: 'Mint',
			pink: 'Pink',
			blue: 'Blue',
			orange: 'Orange',
		},
	},
	'frilly-skirt': {
		name: 'frilly skirt',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			green: 'Green',
			orange: 'Orange',
			purple: 'Purple',
			gray: 'Gray',
		},
	},
	'frilly-sweatpants': {
		name: 'frilly sweatpants',
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			mint: 'Mint',
			orange: 'Orange',
			purple: 'Purple',
			gray: 'Gray',
		},
	},
	'fringe-skirt': {
		name: 'fringe skirt',
		variations: {
			camel: 'Camel',
			black: 'Black',
			white: 'White',
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			'berry-red': 'Berry red',
		},
	},
	'gaucho-pants': {
		name: 'gaucho pants',
		variations: {
			gray: 'Gray',
			brown: 'Brown',
			avocado: 'Avocado',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'geometric-print-pants': {
		name: 'geometric-print pants',
		variations: {
			blue: 'Blue',
			red: 'Red',
			brown: 'Brown',
			'navy-blue': 'Navy blue',
			orange: 'Orange',
		},
	},
	'gingham-picnic-skirt': {
		name: 'gingham picnic skirt',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
			orange: 'Orange',
			pink: 'Pink',
			purple: 'Purple',
			'light-blue': 'Light blue',
		},
	},
	'gobelin-shorts': {
		name: 'gobelin shorts',
		variations: {
			beige: 'Beige',
			black: 'Black',
		},
	},
	'grass-skirt': {
		name: 'grass skirt',
		variations: {
			brown: 'Brown',
		},
	},
	'green-grass-skirt': {
		name: 'green grass skirt',
		variations: {
			green: 'Green',
		},
	},
	'hickory-stripe-pants': {
		name: 'hickory-stripe pants',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
		},
	},
	'jogging-shorts': {
		name: 'jogging shorts',
		variations: {
			pink: 'Pink',
			'light-blue': 'Light blue',
			lime: 'Lime',
			red: 'Red',
			blue: 'Blue',
			black: 'Black',
			purple: 'Purple',
			orange: 'Orange',
		},
	},
	kilt: {
		name: 'kilt',
		variations: {
			red: 'Red',
			black: 'Black',
			'navy-blue': 'Navy blue',
			green: 'Green',
		},
	},
	'knit-pants': {
		name: 'knit pants',
		variations: {
			gray: 'Gray',
			brown: 'Brown',
			'light-blue': 'Light blue',
			red: 'Red',
		},
	},
	'knit-skirt': {
		name: 'knit skirt',
		variations: {
			brown: 'Brown',
			'light-blue': 'Light blue',
			pink: 'Pink',
			mustard: 'Mustard',
		},
	},
	'kung-fu-pants': {
		name: 'kung-fu pants',
		variations: {
			'navy-blue': 'Navy blue',
			white: 'White',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			green: 'Green',
		},
	},
	'labelle-shorts': {
		name: 'Labelle shorts',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'labelle-skirt': {
		name: 'Labelle skirt',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'lace-shorts': {
		name: 'lace shorts',
		variations: {
			white: 'White',
			black: 'Black',
			green: 'Green',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'lace-skirt': {
		name: 'lace skirt',
		variations: {
			white: 'White',
			pink: 'Pink',
			green: 'Green',
			beige: 'Beige',
		},
	},
	'lemon-skirt': {
		name: 'lemon skirt',
		variations: {
			'light-blue': 'Light blue',
			white: 'White',
			black: 'Black',
		},
	},
	'leopard-miniskirt': {
		name: 'leopard miniskirt',
		variations: {
			brown: 'Brown',
			gray: 'Gray',
			blue: 'Blue',
			lime: 'Lime',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	'long-chino-skirt': {
		name: 'long chino skirt',
		variations: {
			beige: 'Beige',
			brown: 'Brown',
			'navy-blue': 'Navy blue',
			avocado: 'Avocado',
			gray: 'Gray',
		},
	},
	'long-denim-skirt': {
		name: 'long denim skirt',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			'navy-blue': 'Navy blue',
			black: 'Black',
			white: 'White',
		},
	},
	'long-plaid-skirt': {
		name: 'long plaid skirt',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			beige: 'Beige',
		},
	},
	'long-pleated-skirt': {
		name: 'long pleated skirt',
		variations: {
			'ruby-red': 'Ruby red',
			white: 'White',
			yellow: 'Yellow',
			cyan: 'Cyan',
			gray: 'Gray',
		},
	},
	'long-polka-skirt': {
		name: 'long polka skirt',
		variations: {
			black: 'Black',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			orange: 'Orange',
			yellow: 'Yellow',
			pink: 'Pink',
			'light-blue': 'Light blue',
		},
	},
	'long-sailor-skirt': {
		name: 'long sailor skirt',
		variations: {
			'navy-blue': 'Navy blue',
			orange: 'Orange',
			'light-blue': 'Light blue',
			green: 'Green',
			brown: 'Brown',
			purple: 'Purple',
			red: 'Red',
			pink: 'Pink',
		},
	},
	'long-sweatskirt': {
		name: 'long sweatskirt',
		variations: {
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'muay-thai-shorts': {
		name: 'muay-thai shorts',
		variations: {
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'multicolor-shorts': {
		name: 'multicolor shorts',
		variations: {
			green: 'Green',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'noble-pants': {
		name: 'noble pants',
		variations: {
			black: 'Black',
			'ruby-red': 'Ruby red',
			white: 'White',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			yellow: 'Yellow',
			red: 'Red',
		},
	},
	'outdoor-shorts': {
		name: 'outdoor shorts',
		variations: {
			yellow: 'Yellow',
			black: 'Black',
			purple: 'Purple',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			brown: 'Brown',
			'yellow-green': 'Yellow-green',
		},
	},
	'patched-knee-pants': {
		name: 'patched-knee pants',
		variations: {
			brown: 'Brown',
			purple: 'Purple',
			green: 'Green',
			yellow: 'Yellow',
		},
	},
	'patchwork-skirt': {
		name: 'patchwork skirt',
		variations: {
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
			green: 'Green',
		},
	},
	'pearl-skirt': {
		name: 'pearl skirt',
		variations: {
			'navy-blue': 'Navy blue',
		},
	},
	'petal-skirt': {
		name: 'petal skirt',
		variations: {
			cool: 'Cool',
			rainbow: 'Rainbow',
			pastel: 'Pastel',
		},
	},
	'pineapple-aloha-shorts': {
		name: 'pineapple aloha shorts',
		variations: {
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
			green: 'Green',
			purple: 'Purple',
			pink: 'Pink',
			orange: 'Orange',
		},
	},
	'plaid-shorts': {
		name: 'plaid shorts',
		variations: {
			'light-blue': 'Light blue',
			brown: 'Brown',
			'light-green': 'Light green',
			red: 'Red',
		},
	},
	'pleather-flare-skirt': {
		name: 'pleather flare skirt',
		variations: {
			brown: 'Brown',
			black: 'Black',
			pink: 'Pink',
			blue: 'Blue',
			green: 'Green',
			orange: 'Orange',
			'light-blue': 'Light blue',
			white: 'White',
		},
	},
	'pleather-pants': {
		name: 'pleather pants',
		variations: {
			black: 'Black',
			brown: 'Brown',
			beige: 'Beige',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'pleather-patch-skirt': {
		name: 'pleather patch skirt',
		variations: {
			red: 'Red',
			green: 'Green',
			purple: 'Purple',
			orange: 'Orange',
		},
	},
	'pleather-shorts': {
		name: 'pleather shorts',
		variations: {
			black: 'Black',
			brown: 'Brown',
			white: 'White',
			red: 'Red',
		},
	},
	'pleather-skirt': {
		name: 'pleather skirt',
		variations: {
			black: 'Black',
			brown: 'Brown',
			beige: 'Beige',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'plover-skirt': {
		name: 'plover skirt',
		variations: {
			red: 'Red',
			black: 'Black',
			green: 'Green',
		},
	},
	'polka-dot-mini-skirt': {
		name: 'polka-dot mini skirt',
		variations: {
			beige: 'Beige',
			pink: 'Pink',
			blue: 'Blue',
			gray: 'Gray',
		},
	},
	'punk-pants': {
		name: 'punk pants',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'rain-pants': {
		name: 'rain pants',
		variations: {
			yellow: 'Yellow',
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			pink: 'Pink',
			red: 'Red',
			beige: 'Beige',
			black: 'Black',
		},
	},
	'sailor-skirt': {
		name: 'sailor skirt',
		variations: {
			'navy-blue': 'Navy blue',
			orange: 'Orange',
			'light-blue': 'Light blue',
			green: 'Green',
			brown: 'Brown',
			purple: 'Purple',
			red: 'Red',
			pink: 'Pink',
		},
	},
	'satin-pants': {
		name: 'satin pants',
		variations: {
			green: 'Green',
			blue: 'Blue',
			'light-purple': 'Light purple',
			pink: 'Pink',
			'dark-red': 'Dark red',
			'ruby-red': 'Ruby red',
			brown: 'Brown',
		},
	},
	'school-pants': {
		name: 'school pants',
		variations: {
			black: 'Black',
			'berry-red': 'Berry red',
			green: 'Green',
			white: 'White',
			purple: 'Purple',
			gray: 'Gray',
			blue: 'Blue',
		},
	},
	'silk-floral-print-pants': {
		name: 'silk floral-print pants',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			mustard: 'Mustard',
			gray: 'Gray',
			purple: 'Purple',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'silk-pants': {
		name: 'silk pants',
		variations: {
			green: 'Green',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
			black: 'Black',
		},
	},
	'ski-pants': {
		name: 'ski pants',
		variations: {
			turquoise: 'Turquoise',
			red: 'Red',
			'ruby-red': 'Ruby red',
			blue: 'Blue',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
		},
	},
	slacks: {
		name: 'slacks',
		variations: {
			black: 'Black',
			gray: 'Gray',
			blue: 'Blue',
			red: 'Red',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
			white: 'White',
		},
	},
	'soccer-shorts': {
		name: 'soccer shorts',
		variations: {
			green: 'Green',
			red: 'Red',
			'navy-blue': 'Navy blue',
			blue: 'Blue',
			'light-blue': 'Light blue',
			white: 'White',
			orange: 'Orange',
			black: 'Black',
		},
	},
	'spangle-shorts': {
		name: 'spangle shorts',
		variations: {
			red: 'Red',
			'navy-blue': 'Navy blue',
			gold: 'Gold',
			silver: 'Silver',
			black: 'Black',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'sporty-skirt': {
		name: 'sporty skirt',
		variations: {
			gray: 'Gray',
			pink: 'Pink',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'striped-bell-bottoms': {
		name: 'striped bell-bottoms',
		variations: {
			yellow: 'Yellow',
			red: 'Red',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'striped-pants': {
		name: 'striped pants',
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
			red: 'Red',
			black: 'Black',
		},
	},
	'striped-shorts': {
		name: 'striped shorts',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'surfing-shorts': {
		name: 'surfing shorts',
		variations: {
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
			pink: 'Pink',
			gray: 'Gray',
		},
	},
	sweatpants: {
		name: 'sweatpants',
		variations: {
			gray: 'Gray',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
			'light-blue': 'Light blue',
			black: 'Black',
		},
	},
	'tennis-skirt': {
		name: 'tennis skirt',
		variations: {
			white: 'White',
			'navy-blue': 'Navy blue',
			'light-blue': 'Light blue',
			pink: 'Pink',
		},
	},
	'terry-cloth-shorts': {
		name: 'terry-cloth shorts',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	'three-quarter-sweatpants': {
		name: 'three-quarter sweatpants',
		variations: {
			mint: 'Mint',
			pink: 'Pink',
			'light-blue': 'Light blue',
			orange: 'Orange',
			black: 'Black',
			yellow: 'Yellow',
			red: 'Red',
			purple: 'Purple',
		},
	},
	'tie-dye-skirt': {
		name: 'tie-dye skirt',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			orange: 'Orange',
		},
	},
	'tiered-skirt': {
		name: 'tiered skirt',
		variations: {
			purple: 'Purple',
			mint: 'Mint',
			avocado: 'Avocado',
			yellow: 'Yellow',
			blue: 'Blue',
		},
	},
	'torn-pants': {
		name: 'torn pants',
		variations: {
			brown: 'Brown',
			black: 'Black',
			gray: 'Gray',
		},
	},
	'track-pants': {
		name: 'track pants',
		variations: {
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			white: 'White',
			red: 'Red',
			'light-blue': 'Light blue',
			green: 'Green',
			blue: 'Blue',
		},
	},
	'traditional-monpe-pants': {
		name: 'traditional monpe pants',
		variations: {
			'dark-blue': 'Dark blue',
			blue: 'Blue',
			'golden-yellow': 'Golden yellow',
			'dark-red': 'Dark red',
		},
	},
	'traditional-suteteko-pants': {
		name: 'traditional suteteko pants',
		variations: {
			red: 'Red',
			'yellow-green': 'Yellow-green',
			'golden-yellow': 'Golden yellow',
			purple: 'Purple',
			aqua: 'Aqua',
			blue: 'Blue',
		},
	},
	'tweed-frilly-skirt': {
		name: 'tweed frilly skirt',
		variations: {
			brown: 'Brown',
			gray: 'Gray',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'tweed-pants': {
		name: 'tweed pants',
		variations: {
			brown: 'Brown',
			blue: 'Blue',
			beige: 'Beige',
			'berry-red': 'Berry red',
			green: 'Green',
			pink: 'Pink',
		},
	},
	'tweed-skirt': {
		name: 'tweed skirt',
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'two-tone-pants': {
		name: 'two-tone pants',
		variations: {
			blue: 'Blue',
			monotone: 'Monotone',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'upcycled-skirt': {
		name: 'upcycled skirt',
		variations: {
			beige: 'Beige',
			pink: 'Pink',
			mint: 'Mint',
		},
	},
	'vibrant-shorts': {
		name: 'vibrant shorts',
		variations: {
			orange: 'Orange',
			avocado: 'Avocado',
			pink: 'Pink',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'western-pants': {
		name: 'western pants',
		variations: {
			brown: 'Brown',
		},
	},
	'wide-chino-pants': {
		name: 'wide chino pants',
		variations: {
			brown: 'Brown',
			beige: 'Beige',
			'navy-blue': 'Navy blue',
			avocado: 'Avocado',
			gray: 'Gray',
		},
	},
	'workout-pants': {
		name: 'workout pants',
		variations: {
			lime: 'Lime',
			pink: 'Pink',
			orange: 'Orange',
		},
	},
	'worn-out-cutoffs': {
		name: 'worn-out cutoffs',
		variations: {
			'light-blue': 'Light blue',
			blue: 'Blue',
			white: 'White',
			black: 'Black',
		},
	},
	'worn-out-jeans': {
		name: 'worn-out jeans',
		variations: {
			'light-blue': 'Light blue',
			blue: 'Blue',
			white: 'White',
			black: 'Black',
		},
	},
	'yacht-shorts': {
		name: 'yacht shorts',
		variations: {
			'light-blue': 'Light blue',
			red: 'Red',
			pink: 'Pink',
			purple: 'Purple',
		},
	},
};

export { _bottoms };
